module.exports = __webpack_public_path__ + "static/media/phone-24.33a4ec87.png";